// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-close[data-v-27532995] {\n  max-width: 1200px;\n}[dir] .container-close[data-v-27532995] {\n  margin: 0 auto;\n}", ""]);
// Exports
module.exports = exports;
